module.exports = __webpack_public_path__ + "img/Support-skill-208.5e0867ce.png";